/* Delegated handlers survive Shopify section replacement, hiding and reordering. */
(function () {
  if (window.epProductLayoutLoaded) return;
  window.epProductLayoutLoaded = true;

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.name !== 'id' || !input.closest('[data-variant-picker]')) return;
    var section = input.closest('.ep-product');
    if (!section) return;
    var dataElement = section.querySelector('#ep-variant-data');
    if (!dataElement) return;
    var variants;
    try { variants = JSON.parse(dataElement.textContent); } catch (error) { return; }
    var variant = variants[input.value];
    if (!variant) return;
    if (variant.img) {
      var image = section.querySelector('.ep-product__media img');
      if (image) {
        image.src = variant.img;
        if (variant.srcset) image.srcset = variant.srcset;
        else image.removeAttribute('srcset');
      }
    }
    if (variant.price) {
      var price = section.querySelector('.ep-product__price');
      if (price) price.textContent = variant.price;
    }
    var swatch = input.closest('.ep-swatch');
    var title = swatch ? swatch.getAttribute('data-variant-title') :
      (input.options && input.selectedIndex >= 0 ? input.options[input.selectedIndex].text : null);
    var name = section.querySelector('#ep-variant-name');
    if (title && name) name.textContent = title;
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-product-quote-trigger]');
    if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey ||
        event.ctrlKey || event.shiftKey || event.altKey) return;
    var form = document.getElementById('ep-quote-form');
    var quote = document.getElementById('ep-quote');
    // Keep the ordinary Contact-page link when the editable enquiry section is absent.
    if (!form || !quote) return;
    event.preventDefault();
    var type = trigger.getAttribute('data-enquiry-type');
    var product = trigger.getAttribute('data-enquiry-product');
    var typeSelect = form.querySelector('#ep-quote-type');
    var productInput = form.querySelector('#ep-quote-product');
    if (product && productInput) productInput.value = product;
    if (type && typeSelect) {
      var aliases = { machines: 'machine', grinders: 'grinder', accessories: 'accessories & parts' };
      var normalised = type.trim().toLowerCase();
      normalised = aliases[normalised] || normalised;
      for (var index = 0; index < typeSelect.options.length; index++) {
        if (typeSelect.options[index].text.replace(/&amp;/g, '&').trim().toLowerCase() === normalised) {
          typeSelect.selectedIndex = index;
          break;
        }
      }
    }
    quote.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    window.setTimeout(function () {
      if (!form.isConnected) return;
      var field = form.querySelector('input:not([type=hidden]),select,textarea');
      if (field) field.focus({ preventScroll: true });
    }, 420);
  });
})();
